<script lang="ts">
  import clsx from 'clsx';
  import { Link } from '@athena-lib/Link';
  import { Text } from '@athena-lib/Text';
  import MutationButton from '@athena-lib/MutationButton/MutationButton.svelte';
  import Image from '@athena-lib/Image/Image.svelte';
  import { type BuyStickerCardProps } from './types';

  const {
    small,
    price,
    sticker,
    image,
    onBuyClick,
    onStickerClick,
    formattedSize,
  }: BuyStickerCardProps = $props();
</script>

<div class="flex h-full flex-col justify-between gap-3">
  <a href={sticker.url} onclick={onStickerClick} aria-label={image.alt}>
    <div class="aspect-square content-center bg-st-gray-100">
      <Image
        class={clsx(small ? 'p-2' : 'p-2 md:p-8')}
        src={image.src}
        alt={image?.alt ?? ''}
        loading="lazy"
      />
    </div>
  </a>
  <div class="flex flex-col justify-between">
    <Link
      href={sticker.url}
      class="overflow-hidden overflow-ellipsis whitespace-nowrap text-nowrap text-base font-bold uppercase hover:underline"
    >
      {sticker.name}
    </Link>
    <Text>{formattedSize}</Text>
  </div>

  <MutationButton
    size="small"
    class={clsx(small && '!min-w-20')}
    color="dark"
    createPromise={onBuyClick}
  >
    {price}
  </MutationButton>
</div>
